import ContractList from "../../fragments/contract-list";

function EmployeeContractsList({ employeeId }) {
  return <ContractList contractObjectType={"employee"} contractObjectId={employeeId} navigationBasePath={`/employee/${employeeId}/contracts`} />
}

export default EmployeeContractsList;